import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const LinkContent = styled.div`
    label: LinkContent;

    cursor: pointer;
    flex: 1;
    display: inline-block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    font-family: effra, he Helvetica, Arial, sans-serif;

    ${({ theme }) => {
        console.log(theme);
        if (theme === "blue") {
            return `
                a {
                    text-decoration: none;
                    color: #0098DB;
                }
            `;
        }
        if (theme === "black") {
            return `
                a {
                    text-decoration: none;
                    color: #262626;
                }
            `;
        }
        if (theme === "white") {
            return `
                a {
                    text-decoration: none;
                    color: #ffffff;
                }
            `;
        }
    }};
    ${({ align }) => {
        console.log(align);
        if (align === "left") {
            return `
                a {
                    text-align: left;
                }
            `;
        }
        if (align === "center") {
            return `
                a {
                    text-align: center;
                }
            `;
        }
        if (align === "right") {
            return `
                a {
                    text-align: right;
                }
            `;
        }
    }};
`;
const Link = ({ align, dataQa, label, theme, url, className, children }) => (
    <LinkContent data-qa={dataQa} className={className} align={align} theme={theme}>
        <a href={url} target="_blank" rel="noopener noreferrer">
            {label} {children}
        </a>
    </LinkContent>
);

export const LinkPropTypes = {
    dataQa: PropTypes.string,
    url: PropTypes.string.isRequired,
    label: PropTypes.string,
    align: PropTypes.oneOf(["left", "center", "right"]),
    theme: PropTypes.oneOf(["blue", "black", "white"])
};
Link.propTypes = LinkPropTypes;
Link.defaultProps = {
    align: "center",
    theme: "blue"
};
export default Link;
